module.exports = __webpack_public_path__ + "static/media/portrait.4614a9ca.svg";